import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: { label: string; to: string };
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500/15 text-primary-300">
              <i className={icon} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action && (
        <Link
          to={action.to}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-accent-400"
        >
          {action.label}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}